import { Controller } from "@hotwired/stimulus";

const COLOR_CLASSES = ["text-danger", "text-warning", "text-success"];

export default class extends Controller {
  static targets = ["reason", "field", "note", "guidance", "feedback"];
  static values = { guidance: Object, min: Number, good: Number };

  connect() {
    this.reasonChanged();
  }

  reasonChanged() {
    const reason = this.reasonTarget.value;

    if (reason) {
      this.fieldTarget.classList.remove("hidden");
    } else {
      this.fieldTarget.classList.add("hidden");
    }

    this.setGuidance(reason);
    this.updateFeedback();
  }

  setGuidance(reason) {
    const copy = this.guidanceValue[reason];

    this.guidanceTarget.textContent = copy || "";
    this.guidanceTarget.classList.toggle("hidden", !copy);
  }

  updateFeedback() {
    const length = this.noteTarget.value.trim().length;

    this.feedbackTarget.classList.remove(...COLOR_CLASSES);

    if (length === 0) {
      this.feedbackTarget.textContent = "";
      return;
    }

    const { className, message } = this.feedbackFor(length);
    this.feedbackTarget.classList.add(className);
    this.feedbackTarget.textContent = message;
  }

  feedbackFor(length) {
    if (length < this.minValue) {
      return {
        className: "text-danger",
        message: "Add a bit more detail",
      };
    }
    if (length <= this.goodValue) {
      return {
        className: "text-warning",
        message: "Good — a little more context helps",
      };
    }
    return {
      className: "text-success",
      message: "Perfect, this is exactly what we need",
    };
  }
}
